'use client'

import { useState } from 'react'
import BlogCard from './BlogCard'
import ViewToggle from './ViewToggle'
import { IStoriesAPIResponseDataArticlesEntity } from '@/src/types/stories'

interface BlogsContentProps {
  posts: IStoriesAPIResponseDataArticlesEntity[]
}

export default function BlogsContent({ posts }: BlogsContentProps) {
  const [view, setView] = useState<'grid' | 'list'>('grid')

  return (
    <div className="custom_container space-y-8 pb-16">
      <ViewToggle view={view} onChange={setView} totalPosts={posts.length} />

      {view === 'grid' ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
          {posts.map((post) => (
            <BlogCard key={post.id} post={post} view="grid" />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-4 md:gap-5">
          {posts.map((post) => (
            <BlogCard key={post.id} post={post} view="list" />
          ))}
        </div>
      )}
    </div>
  )
}
